import { useEffect, useState } from 'react';
import '../css/App.css';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { CombData } from "./CombData";
import { Combination } from "./Combination";
import Button from './component/Button';
import Card from './component/Card';
import ImobileBanner from "./banner";

// import { AdsInFeed } from './component/AdsInFeed';

function Home() {
	const navigate = useNavigate();
	const location = useLocation();
	const locationState = location.state;
	const nowBattleCnt: number | null = locationState?.nowBattleCnt ?? null;
	const resultData: CombData | null = locationState?.combData ?? null;

	const [playerCnt, setPlayerCnt] = useState<number>(() => {
		return parseInt(localStorage.getItem('playerCnt') || '10');
	}); // 参加人数
	const [battleCnt, setBattleCnt] = useState<number>(() => {
		return parseInt(localStorage.getItem('battleCnt') || '50');
	}); // 対戦回数
	const generateArray = (num: number): number[] => Array.from({ length: num }, (_, i) => i);
	const [displayPlayers, setDisplayPlayers] = useState<number[]>(JSON.parse(localStorage.getItem('displayPlayers') ?? '[]')); // 除外する番号

	const players = generateArray(resultData?.playerCnt ?? 0); // 戻ってきた時の人数
	// 画面に戻ってきた時の処理
	useEffect(() => {
		localStorage.setItem('playerCnt', playerCnt.toString());
		localStorage.setItem('battleCnt', battleCnt.toString());
		localStorage.setItem('displayPlayers', JSON.stringify(displayPlayers));

	}, [playerCnt, battleCnt, displayPlayers]);

	// リセットボタンが押された時
	const reloadClick = () => {
		var root = document.getElementById('root');
		if (root?.dataset.version !== '1.1.2') {
			window.location.href = window.location.href + ''; // エラー回避の為（同じURLを代入できないため） 
		}

		setPlayerCnt(10);
		setBattleCnt(50);
		setDisplayPlayers([]);
		localStorage.clear();
		navigate(window.location.pathname, { replace: true, state: null });
	}

	// 「開始」or「再開」ボタンをクリック
	const handleClick = () => {
		let combData;
		if (resultData) {
			const comb = new Combination(resultData);
			combData = comb.reCalMatches(nowBattleCnt ?? 0, playerCnt - (resultData?.playerCnt ?? 0), displayPlayers);

			// 変更履歴の追加
			combData.changeHistory.push({ playerCnt: playerCnt, battleCnt: nowBattleCnt ?? 0, displayPlayers: displayPlayers });
		} else {
			combData = new CombData(playerCnt, battleCnt);
			const comb = new Combination(combData);
			comb.calMatchese(); // 対戦相手を計算する
		}

		navigate("/list", {
			state: { combData: combData, }
		});
	};

	return (
		<>
			<ImobileBanner />
			<header className="App-header">
				<h1 className="flex justify-between items-center">
					<span className='font-bold'>ダブルス組み合わせ表の作成ツール</span>
				</h1>
			</header>
			<div className="App relative mx-auto p-2 lg:p-6">
				<section className="mb-6">
					<p className="text-sm text-gray-600">
						アプリ版では名前設定や詳細な条件設定など、
						より多くの機能を利用できます。
					</p>
				</section>
				<div className='w-full flex justify-center mb-4'>
					<a href="https://apps.apple.com/jp/app/id6745511996?"
						className="display: inline-block;">
						<img src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/ja-jp?releaseDate=1746576000"
							alt="App Storeでダウンロード" width="100px" height="40px" />
					</a>

					<a href="https://play.google.com/store/apps/details?id=work.team_combi" className="display: inline-block; ml-4">
						<img src="https://nabettu.github.io/appreach/img/gplay_ja.png" width="120px" height="50px" />
					</a>
				</div>

				<div className='w-full flex justify-between items-center'>
					<Button onClick={reloadClick}> リセット</Button>

					<div className="flex flex-col justify-center items-end">
						<div className={`text-end text-sm lg:text-3xl ${nowBattleCnt ? '' : 'invisible'}`}>
							現在:
							<span className="lg:text-4xl lg:mx-2 text-lg mx-1">{nowBattleCnt}</span>
							試合
							<span className="text-lg lg:text-4xl lg:mx-2 mx-1">
								{resultData?.playerCnt ?? 0}
							</span>
							人
						</div>

						<div className="lg:text-3xl text-gray-500 text-sm text-end flex items-center">
							<span>試合回数</span>
							<input
								className="lg:text-3xl lg:w-16 lg:mx-2 mx-1 w-10 bg-green-50 opacity-70 text-center text-base text-black border border-gray-400 rounded-md font-semibold"
								type="number"
								value={battleCnt}
								onChange={(e) => {
									const target_num = parseInt(e.target.value === '' ? '0' : e.target.value);
									setBattleCnt(target_num);
								}}
							/>
							<span>回</span>
						</div>

						<div className="lg:text-3xl mt-0.5 text-gray-500 text-sm text-end flex items-center">
							<span>参加人数</span>
							<input
								className="lg:text-3xl lg:w-16 lg:mx-2 mx-1 w-10 bg-green-50 opacity-70 text-center text-base text-black border border-gray-400 rounded-md font-semibold"
								type="number"
								value={playerCnt}
								onChange={(e) => {
									const target_num = parseInt(e.target.value === '' ? '0' : e.target.value);
									setPlayerCnt(target_num);
								}}
							/>
							<span>人</span>
						</div>
					</div>
				</div>

				<h3 className='lg:mt-12 font-bold text-start'>人数選択</h3>
				<Card className='lg:mt-6 m-2'>
					<div className='grid grid-cols-7'>
						{generateArray(28).map((date, index) => { // 一旦、31人までボタン表示 
							return (
								<button key={index}
									className={`${index + 4 < (resultData?.playerCnt ?? 0) ? 'text-gray-300' : 'border rounded-md'} ${index + 4 === playerCnt ? 'bg-green-700 text-white border-black font-bold' : 'text-gray-500 border-gray-400'} m-1 sm:w-11 lg:w-24 lg:text-lg `}
									onClick={index + 4 < (resultData?.playerCnt ?? 0) ? () => { } : () => {
										setPlayerCnt(index + 4);
									}}
								>{index + 4}<span className="text-xs lg:text-sm">人</span></button>
							)
						})}
					</div>
				</Card>

				{resultData !== null &&
					(<>
						<h3 className='lg:mt-12 font-bold text-start'>不参加の番号</h3>
						<Card className='lg:mt-6 mt-2'>

							<div className='mx-auto w-64 lg:w-[680px] justify-items-center grid grid-cols-5 gap-0'>
								{players.map((date, index) => {
									var isUse: Boolean = !displayPlayers.includes(index);
									return (
										<button
											key={index}
											className={`${isUse ? 'bg-green-700 text-white' : 'text-gray-400'} m-1 w-10 lg:w-24  border border-gray-400 rounded-md`}
											onClick={() => {
												// 既にある場合は削除しない場合は追加する。
												if (isUse) {
													setDisplayPlayers([...displayPlayers, index]);
												} else {
													setDisplayPlayers(displayPlayers.filter(num => num !== index));
												}
											}}
										>{index + 1}</button>
									)
								})}
							</div>
						</Card>
					</>)}

				<Button onClick={handleClick} className='lg:mt-6 lg:w-36 mt-2 w-20  bg-green-700'>開始</Button>
			</div >
		</>
	);
}

export default Home;